import * as Dialog from "../framework/dialog";
import { getUITranslation } from "../utils/get_ui_translation";
import { initAutocomplete } from "../framework/autocomplete";
import { fieldHoldsInput } from "./funding_row";

document.querySelectorAll(".edit-customer-form").forEach(function (element) {
  element.addEventListener("submit", onSubmitCustomer);
});

document.querySelectorAll(".js-funding-agency-id").forEach(function (element) {
  addFundingAgency(element);
  element.addEventListener("change", onAddFundingAgency);
});

document.addEventListener("dynamic_list_changed", (ev) => {
  if (ev.detail.type === "add") {
    ev.detail.added.querySelector(".js-funding-agency-id")?.addEventListener("change", onAddFundingAgency);
  }
});

function onSubmitCustomer(e) {
  if (blockOnFundingWithoutAgency(e)) {
    return;
  }

  blockOnMissingFundingAmount(e);
}

// The server refuses a funding row that was filled without a funding agency, but it redisplays the
// form from the stored values, so the user loses whatever the autocompletes held. Say it before
// anything is submitted. This also covers a funder or contact name typed without picking a
// suggestion, which the server never sees: only the hidden ids reach the customer params, the typed
// text is submitted under its own root key.
function blockOnFundingWithoutAgency(e) {
  const incomplete = Array.from(document.querySelectorAll(".js-funding")).filter(
    (row) => !row.querySelector(".js-funding-agency-id")?.value && hasFundingInput(row)
  );

  if (incomplete.length === 0) {
    return false;
  }

  e.preventDefault();
  warnAboutFundingWithoutAgency(incomplete[0]);

  return true;
}

// Same order as the content editor when it blocks a save on a validation error: wait for the modal,
// then bring the offending element into view. The funding block sits at the bottom of a long form.
async function warnAboutFundingWithoutAgency(row) {
  await Dialog.alertError(
    getUITranslation("Erreur sur les financements"),
    getUITranslation("Choisissez un financeur externe dans la liste, ou videz les autres champs de ce financement")
  );

  row.scrollIntoView({ behavior: "smooth", block: "center" });
  // Without preventScroll, focus() runs its own instant scroll and cancels the smooth one above.
  row.querySelector(".funding-agency-name")?.focus({ preventScroll: true });
}

function hasFundingInput(row) {
  return Array.from(row.querySelectorAll("input, select, textarea")).some((field) => fieldHoldsInput(field));
}

function blockOnMissingFundingAmount(e) {
  if (document.querySelectorAll(".js-funding").length > 1) {
    let hasNil = false;
    document.querySelectorAll(".js-funding-amount input").forEach(function (element) {
      hasNil = hasNil || !element.value;
    });
    if (hasNil) {
      e.preventDefault();
      Dialog.alert(
        getUITranslation("Erreur sur les financements"),
        getUITranslation("S'il y a plus d'un financeur, il faut entrer pour chacun d'entre eux le montant financé"),
        "error"
      );
    }
  }
}

function addFundingAgency(e) {
  // The problem: Autocomplete added div around the .text-input, and when we want to refresh it, it's imbrique all selected
  // Here we manage it

  // Find the div with the customer funding div
  const divCustomerFunding = e.closest(".js-funding");
  // Find the input to clone
  const contactDivToClone = divCustomerFunding.querySelector(".js-funding-agency-contact-email [data-autocomplete]");

  // If no contact autocomplete we donit need to that
  if (contactDivToClone) {
    const fundingAgencyId = e.value;

    if (fundingAgencyId) {
      //Then apply autocomplete to the input -> Avoid to change value on others contact input
      let $e = $(contactDivToClone); // Sorry for that, autocomplete run with JQuery

      let initFundingAgencyContactAutocomplete = initAutocomplete(
        p`/ajax/contact_funding_agencies/autocomplete/${fundingAgencyId}`,
        `js-refresh-contacts${fundingAgencyId}`,
        `contacts`,
        getUITranslation("Créer un nouveau contact"),
        getUITranslation("Aucun contact trouvé pour ce financement externe"),
        function (c) {
          let text = "";
          if (c.email) {
            text = c.email + " - " + c.lastname;
          } else {
            text = c.lastname;
          }
          if (c.firstname) {
            text = text + " " + c.firstname;
          }
          return text;
        }
      );
      initFundingAgencyContactAutocomplete($e);

      contactDivToClone.addEventListener("autocomplete", (ev) => {
        onContactAutocomplete(ev, divCustomerFunding.querySelector(".contact-id"));
      });
    } else {
      // Clean the input when don't have funding agency ID avoiding confusing between remove old value and addded ones

      // Find the contact input, reduce the scope and avoid delete another autocomplete
      const contactDiv = divCustomerFunding.querySelector("div .js-funding-agency-contact-email");

      // Find the label where we want to replace the input
      const contactLabelDivWhereToClone = contactDiv.querySelector(".text-input");
      // Find the added section by autocomplete
      const contactDivToRemove = contactDiv.querySelector(".twitter-typeahead");

      // At the first call we don't have to remove anythings
      if (contactDivToRemove) {
        // clean inputs too
        contactDiv.querySelector(".tt-input").value = "";
        contactDiv.querySelector(".contact-id").value = "";
        let newElement = contactDivToClone.cloneNode(true);
        contactDivToRemove.remove();
        contactLabelDivWhereToClone.append(newElement);
      }
    }
  }

  function onContactAutocomplete({ detail: contact }, contact_div) {
    if (contact) {
      contact_div.value = contact.id;
    } else {
      contact_div.value = null;
    }
  }
}

function onAddFundingAgency(e) {
  addFundingAgency(e.target);
}
